import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose' // NOTE: https://github.com/acdlite/recompose
import Link from 'gatsby-link'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import withWidth from 'material-ui/utils/withWidth'
import {
  withStyles,
} from 'material-ui/styles'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Button from 'material-ui/Button'

import MenuDrawer from './menu-drawer'
import Logo from './logo'

import * as SiteConfig from '../../config/Config'

const styles = theme => ({
  // root: {
  //   // marginTop: theme.spacing.unit * 5,
  //   // width: '100%',
  // },
  appBar: {
    position: 'fixed',
    backgroundColor: theme.palette.primary.dark,
    minHeight: theme.mixins.toolbar.minHeight,
  },
  toolbar: {
    position: 'absolute',
    right: 0,
  },
  button: {
    color: theme.palette.primary.contrastText,
    textDecoration: `none`,
  },
  icon: {
    margin: theme.spacing.unit,
  },
  title: {
    color: theme.palette.text.primary,
    textDecoration: `none`,
  },
  link: {
    textDecoration: `none`,    
  },
})

class Header extends Component {
  render() {
    const {
      classes,
      width,
      pages,
    } = this.props
    
    return(
      <div className={classes.root}>

        {width === "lg" || width === "xl" ? <Logo size="large" /> : null}
        {width === "md" ? <Logo size="medium" /> : null}
        {width === "sm" || width === "xs" ? <Logo size="medium" /> : null}

        <AppBar
          // color="primary"
          className={classes.appBar}
        >
        
          <Toolbar
            className={classes.toolbar}
          >

            <Link to="/" className={classes.link}>
              <Button
                className={`${classes.button}`}
              >
                {width === "xl" && `Home`}
                {width === "lg" && `Home`}

                {width === "xl" && <FontAwesomeIcon
                  icon={SiteConfig.pages.home.headerIcon}
                  className={classes.icon}
                />}
                {width === "lg" && <FontAwesomeIcon
                  icon={SiteConfig.pages.home.headerIcon}
                  className={classes.icon}
                />}
                {width === "md" && <FontAwesomeIcon
                  icon={SiteConfig.pages.home.headerIcon}
                  className={classes.icon}
                />}
              </Button>
            </Link>

            <Link to="/about" className={classes.link}>
              <Button
                className={`${classes.button}`}
              >
                {width === "xl" && `About`}
                {width === "lg" && `About`}

                {width === "xl" && <FontAwesomeIcon
                  icon={SiteConfig.pages.about.headerIcon}
                  className={classes.icon}
                />}
                {width === "lg" && <FontAwesomeIcon
                  icon={SiteConfig.pages.about.headerIcon}
                  className={classes.icon}
                />}
                {width === "md" && <FontAwesomeIcon
                  icon={SiteConfig.pages.about.headerIcon}
                  className={classes.icon}
                />}
              </Button>
            </Link>

            {/* <Link to="/portfolio" className={classes.link}>
              <Button className={`${classes.button}`}>
                {width === "xl" && `Portfolio`}
                {width === "lg" && `Portfolio`}

                {width === "xl" && <FontAwesomeIcon
                  icon={SiteConfig.pages.portfolio.headerIcon}
                  className={classes.icon}
                />}
                {width === "lg" && <FontAwesomeIcon
                  icon={SiteConfig.pages.portfolio.headerIcon}
                  className={classes.icon}
                />}
                {width === "md" && <FontAwesomeIcon
                  icon={SiteConfig.pages.portfolio.headerIcon}
                  className={classes.icon}
                />}
              </Button>
            </Link> */}

            <Link to="/contact" className={classes.link}>
              <Button
                className={`${classes.button}`}
              >
                {width === "xl" && `Contact`}
                {width === "lg" && `Contact`}

                {width === "xl" && <FontAwesomeIcon
                  icon={SiteConfig.pages.contact.headerIcon}
                  className={classes.icon}
                />}
                {width === "lg" && <FontAwesomeIcon
                  icon={SiteConfig.pages.contact.headerIcon}
                  className={classes.icon}
                />}
                {width === "md" && <FontAwesomeIcon
                  icon={SiteConfig.pages.contact.headerIcon}
                  className={classes.icon}
                />}
              </Button>
            </Link>

            {SiteConfig.login &&
              <Button
                href={SiteConfig.login.url}
                className={`${classes.button}`}
              >
                {width === "xl" && `Login`}
                {width === "lg" && `Login`}
                
                {width === "xl" && <FontAwesomeIcon
                  icon={SiteConfig.login.icon}
                  className={classes.icon}
                />}
                {width === "lg" && <FontAwesomeIcon
                  icon={SiteConfig.login.icon}
                  className={classes.icon}
                />}
                {width === "md" && <FontAwesomeIcon
                  icon={SiteConfig.login.icon}
                  className={classes.icon}
                />}
              </Button>
            }

            <MenuDrawer />

          </Toolbar>

        </AppBar>
      </div>
    )

  } // END: render
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  width: PropTypes.string,
}

export default compose(
  withStyles(styles),
  withWidth()
)(Header)


// WEBPACK FOOTER //
// ./src/components/Header/index.js